import React from "react";
import { motion } from "framer-motion";
import { ArrowUpRight } from "lucide-react";
import { IMAGES, CONTACT } from "../data/content";
import { fadeUp, staggerContainer, viewportOnce, EYEBROW } from "../lib/motion";

export const About = () => {
  return (
    <section id="tentang" data-testid="about-section" className="relative bg-white py-24 md:py-32 overflow-hidden">
      <div className="max-w-7xl mx-auto px-5 sm:px-8">
        <div className="grid lg:grid-cols-12 gap-12 lg:gap-16 items-center">
          {/* Left: image */}
          <motion.div
            variants={fadeUp}
            initial="hidden"
            whileInView="visible"
            viewport={viewportOnce}
            className="lg:col-span-5"
          >
            <div className="relative rounded-3xl overflow-hidden shadow-medium">
              <img src={IMAGES.handshake} alt="Profesional hukum FYLegal.ID" className="w-full h-[420px] object-cover" />
              <div className="absolute inset-0 bg-gradient-to-t from-navy/55 to-transparent" />
              <div className="absolute bottom-5 left-5 right-5 rounded-2xl bg-white/90 backdrop-blur px-5 py-4">
                <p className="text-sm text-graytone-dark">Di bawah naungan</p>
                <p className="font-serif text-lg font-semibold text-navy">{CONTACT.company}</p>
                <p className="text-xs text-gold-dark mt-0.5">Didirikan Juli 2024</p>
              </div>
            </div>
          </motion.div>

          {/* Right: narrative */}
          <motion.div
            variants={staggerContainer}
            initial="hidden"
            whileInView="visible"
            viewport={viewportOnce}
            className="lg:col-span-7"
          >
            <motion.span variants={fadeUp} className={EYEBROW}>
              Tentang Kami
            </motion.span>
            <motion.h2
              variants={fadeUp}
              className="mt-5 font-serif text-4xl md:text-5xl leading-[1.08] tracking-tight text-navy"
            >
              Solusi Hukum yang <span className="italic text-gold-dark">Profesional, Aman</span> & Terpercaya
            </motion.h2>

            <motion.div variants={fadeUp} className="mt-7 space-y-5 text-graytone-dark text-base md:text-lg leading-relaxed">
              <p>
                Fylegal merupakan layanan hukum di bawah naungan{" "}
                <span className="text-navy font-medium">{CONTACT.company}</span> yang didirikan pada Juli 2024.
                Kami hadir sebagai mitra hukum terpercaya bagi individu, UMKM, startup, hingga perusahaan.
              </p>
              <p>
                Hukum bukan sekadar menyelesaikan masalah, tetapi memberikan kepastian, perlindungan, dan rasa
                aman bagi setiap klien. Setiap orang berhak atas layanan hukum yang profesional, transparan, dan
                mudah diakses.
              </p>
              <p>
                Kami memadukan pendekatan profesional dengan komunikasi yang mudah dipahami masyarakat umum guna
                memastikan Anda selalu memahami setiap langkah, biaya, dan estimasi penyelesaian sejak awal.
              </p>
            </motion.div>

            <motion.a
              variants={fadeUp}
              href="#kontak"
              data-testid="about-cta"
              className="mt-8 inline-flex items-center gap-2 text-navy font-semibold hover:text-gold-dark transition-colors"
            >
              Konsultasikan kebutuhan Anda
              <ArrowUpRight className="h-5 w-5" />
            </motion.a>
          </motion.div>
        </div>
      </div>
    </section>
  );
};
